<template>
  <div class="expenseStatisticsDetail">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-field
            readonly
            :value="monthName"
            :placeholder="$t.expenseStatistics.selectMonth"
            @click-input="pickerShow('showMonthPicker')"
            class="custom-field"
          >
            <template #button>
              <van-button size="small" type="info" @click="onSearch">{{
                $t.meta.search
              }}</van-button>
            </template>
          </van-field>
        </van-col>
      </van-row>
    </div>

    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList"
    >
      <div
        class="list-container"
        v-for="(item, index) in tableData"
        :key="index"
      >
        <div class="list-item">
          {{ $t.expenseStatistics.paymentRecordNumber }}：{{
            item.OperationRecordNumber
          }}
        </div>
        <div class="list-item">
          {{ $t.expenseStatistics.category }}：{{ item.SubCategoryName }}
        </div>
        <div class="list-item">
          {{ $t.expenseStatistics.applicant }}：{{ item.UserName }}
        </div>
        <div class="list-item">
          {{ $t.expenseStatistics.department }}：{{ item.Department }}
        </div>
        <div class="list-item">
          {{ $t.expenseStatistics.submitTime }}：{{ item.SubmitTime }}
        </div>
        <div class="list-item">
          {{ $t.expenseStatistics.submitCount }}：{{ item.SubmitCount }}
        </div>
        <div class="list-item">
          {{ $t.expenseStatistics.currency }}：{{ item.CurrencySn }}
        </div>
        <div class="list-item">
          {{ $t.expenseStatistics.feeAmount }}：{{ item.FeeAmount }}
        </div>
        <div class="list-item">
          {{ $t.expenseStatistics.costCode }}：{{ item.ExpenseVoucherNumber }}
        </div>
        <div class="list-item">
          {{ $t.expenseStatistics.menthodState }}：
          <span v-if="item.PaymentMethod == 1">{{
            $t.expenseStatistics.mState1
          }}</span>
          <span v-if="item.PaymentMethod == 2">{{
            $t.expenseStatistics.mState2
          }}</span>
          <span v-if="item.PaymentMethod == 3">{{
            $t.expenseStatistics.mState3
          }}</span>
        </div>
        <div class="list-item">
          {{ $t.expenseStatistics.approvalState }}：
          <span v-if="item.ApprovalState == 0">{{
            $t.expenseStatistics.aState1
          }}</span>
          <span v-if="item.ApprovalState == 1">{{
            $t.expenseStatistics.aState2
          }}</span>
          <span v-if="item.ApprovalState == 2">{{
            $t.expenseStatistics.aState3
          }}</span>
          <span v-if="item.ApprovalState == 3">{{
            $t.expenseStatistics.aState4
          }}</span>
          <span v-if="item.ApprovalState == 4">{{
            $t.expenseStatistics.aState5
          }}</span>
        </div>
        <div class="list-item">
          {{ $t.expenseStatistics.paymentState }}：
          <span v-if="item.PaymentState == 0">{{
            $t.expenseStatistics.pState1
          }}</span>
          <span v-if="item.PaymentState == 1">{{
            $t.expenseStatistics.pState2
          }}</span>
        </div>
        <div class="list-item">
          {{ $t.expenseStatistics.systemCode }}：{{ item.PaymentSystemCode }}
        </div>
        <div class="list-item">
          {{ $t.expenseStatistics.totalBatch }}：{{ item.TotalBatch }}
        </div>
        <div class="list-item">
          {{ $t.expenseStatistics.uploadDate }}：{{
            item.PaymentVoucherUploadDate
          }}
        </div>

        <div class="buttons">
          <van-button
            class="primary-btn"
            size="small"
            type="primary"
            @click="dialogShow(item.OERId, 1)"
            >{{ $t.expenseStatistics.requestReceipt }}</van-button
          >

          <van-button
            class="primary-btn"
            size="small"
            type="primary"
            @click="dialogShow(item.OERId, 2)"
            >{{ $t.expenseStatistics.payReceipt }}</van-button
          >
        </div>
      </div>
    </van-list>

    <van-dialog
      :title="
        voucherType == 1
          ? $t.expenseStatistics.requestReceipt
          : $t.expenseStatistics.payReceipt
      "
      width="90%"
      v-model="showDialog"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.close"
      :show-cancel-button="true"
      :show-confirm-button="false"
    >
      <slot name="default">
        <div class="fileList-alert">
          <van-form label-width="120px">
            <div class="multi-table" v-if="fileList">
              <van-field name="stepper" :label="$t.expenseStatistics.fileList">
                <template #input>
                  <van-stepper
                    :min="0"
                    :value="fileList.length"
                    :disabled="true"
                  />
                </template>
              </van-field>
              <div v-for="(item, index) in fileList" :key="index">
                <van-field :label="'No.' + (index + 1)">
                  <template #input>
                    <van-image
                      :src="item.VoucherFile && imgUrlFilter(item.VoucherFile)"
                      @click="imagePreview(imgUrlFilter(item.VoucherFile))"
                      width="50"
                      height="50"
                      fit="contain"
                      style="vertical-align: top"
                      v-if="item.VoucherFile"
                    ></van-image>
                  </template>
                </van-field>
              </div>
            </div>
          </van-form>
        </div>
      </slot>
    </van-dialog>

    <van-popup v-model="showMonthPicker" round position="bottom">
      <van-picker
        :title="$t.expenseStatistics.month"
        show-toolbar
        :columns="monthList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="monthConfirm"
        @cancel="showMonthPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import {
  List,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  Popup,
  Picker,
  Image,
  Stepper,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(Popup)
  .use(Picker)
  .use(Image)
  .use(Stepper);

export default {
  name: "expenseStatisticsDetail",
  data() {
    return {
      subCategoryId: "",
      year: "",
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      page: 0,
      pageSize: 10,
      tableData: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //options
      monthList: [],
      monthName: "",
      monthValue: "",
      //picker
      showMonthPicker: false,
      showDialog: false,
      //文件
      fileList: [],
      OERId: "",
      voucherType: 1,
    };
  },
  created() {
    const { SubCategoryId, Year } = this.$route.query;
    this.subCategoryId = SubCategoryId;
    this.year = Year;
  },
  methods: {
    dialogShow(id, type) {
      this.OERId = id;
      this.voucherType = type;
      this.getOperatingExpenseVoucherList().then((success) => {
        if (success) {
          this.showDialog = true;
        }
      });
    },
    getOperatingExpenseVoucherList() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          OERId: this.OERId,
          VoucherType: this.voucherType,
        };
        this.$api.financialManagement
          .getOperatingExpenseVoucherList(param)
          .then((res) => {
            this.fileList = res.data;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(
              this.$commonEnv.actionType.showDialog,
              {
                msg: error.message,
              }
            );
            reject();
          });
      });
    },
    monthConfirm(e) {
      this.monthName = e.text;
      this.monthValue = e.value;
      this.showMonthPicker = false;
    },
    pickerShow(pickerName) {
      this.monthList = [
        {
          text: this.$t.expenseStatistics.month1,
          value: 1,
        },
        {
          text: this.$t.expenseStatistics.month2,
          value: 2,
        },
        {
          text: this.$t.expenseStatistics.month3,
          value: 3,
        },
        {
          text: this.$t.expenseStatistics.month4,
          value: 4,
        },
        {
          text: this.$t.expenseStatistics.month5,
          value: 5,
        },
        {
          text: this.$t.expenseStatistics.month6,
          value: 6,
        },
        {
          text: this.$t.expenseStatistics.month7,
          value: 7,
        },
        {
          text: this.$t.expenseStatistics.month8,
          value: 8,
        },
        {
          text: this.$t.expenseStatistics.month9,
          value: 9,
        },
        {
          text: this.$t.expenseStatistics.month10,
          value: 10,
        },
        {
          text: this.$t.expenseStatistics.month11,
          value: 11,
        },
        {
          text: this.$t.expenseStatistics.month12,
          value: 12,
        },
      ];
      this[pickerName] = true;
    },
    onSearch() {
      this.initList();
      this.getList();
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
    },
    getList() {
      var param = {
        Year: this.year,
        Month: this.monthValue,
        SubCategoryId: this.subCategoryId,
      };
      this.$api.dataSummary
        .costCategoryRequestFundsDetailList(param)
        .then((res) => {
          this.tableData = this.tableData.concat(res.data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.finished = true;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.expenseStatisticsDetail {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 100%;
        text-align: center;
        font-size: 14px;
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
      .buttons {
        text-align: right;
        .primary-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;
      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .fileList-alert {
    overflow: scroll;
    height: 100vw;
    margin-top: 30px;
    .multi-table {
      .multi-table-header {
        background: #ffffff;
        padding: 10px 15px;
        .multi-table-title {
          font-size: 14px;
          color: #999;
          width: 70%;
          display: inline-block;
          vertical-align: middle;
        }
        .multi-table-btn {
          font-size: 20px;
          color: #000;
          width: 30%;
          display: inline-block;
          text-align: right;
          vertical-align: middle;
        }
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    border-top: 1px solid #f6f6f6;
    .tool-button {
      align-items: center;
    }
  }
}
</style>